import { platformApi } from "@/api/http";

export interface UserProfile {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
  acceptingAppointments?: boolean;
  emailVerified?: boolean;
  bio?: string;
  /** Public blob URL of the profile photo, or null when none has been uploaded. */
  avatarUrl?: string | null;
}

export interface UpdateMyProfileRequest {
  firstName?: string;
  lastName?: string;
  phone?: string;
  bio?: string;
  acceptingAppointments?: boolean;
}

export const userApi = {
  getMe: async (): Promise<UserProfile> => {
    const { data } = await platformApi.get("/api/v1/users/me");
    return data as UserProfile;
  },

  updateProfile: async (request: UpdateMyProfileRequest): Promise<UserProfile> => {
    const { data } = await platformApi.patch("/api/v1/users/me", request);
    return data as UserProfile;
  },

  uploadAvatar: async (file: File): Promise<{ avatarUrl: string }> => {
    const formData = new FormData();
    formData.append("file", file);
    const { data } = await platformApi.post("/api/v1/users/me/avatar", formData);
    return data as { avatarUrl: string };
  },

  deleteAvatar: async (): Promise<{ avatarUrl: string | null }> => {
    const { data } = await platformApi.delete("/api/v1/users/me/avatar");
    return data as { avatarUrl: string | null };
  },

  changePassword: async (currentPassword: string, newPassword: string): Promise<void> => {
    await platformApi.post("/api/v1/users/change-password", { currentPassword, newPassword });
  },
};
